import type { TranscriptionConfigQuery } from "@/Modules/Models/Api/User";

import { configTranscription } from "@/Services/TherapyApi/Customers";

import useUserStore from "@/Modules/User/Store";

import { hasValue } from "@/Utils/Objects";

async function configTranscriptionAH(
  transcriptionConfig: TranscriptionConfigQuery
): Promise<boolean | undefined> {
  const userStore = useUserStore();

  if (!hasValue(userStore.user)) return false;

  try {
    await configTranscription(userStore.user.id, transcriptionConfig);

    return true;
  } catch (error: unknown) {
    return false;
  }
}

export default configTranscriptionAH;
